import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ModalService {
  isComingSoonOpen = signal(false);

  openComingSoon(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isComingSoonOpen.set(true);
  }

  closeComingSoon() {
    this.isComingSoonOpen.set(false);
  }
}
